var __decorate = (this && this.__decorate) || function (decorators, target, key, desc) {
    var c = arguments.length, r = c < 3 ? target : desc === null ? desc = Object.getOwnPropertyDescriptor(target, key) : desc, d;
    if (typeof Reflect === "object" && typeof Reflect.decorate === "function") r = Reflect.decorate(decorators, target, key, desc);
    else for (var i = decorators.length - 1; i >= 0; i--) if (d = decorators[i]) r = (c < 3 ? d(r) : c > 3 ? d(target, key, r) : d(target, key)) || r;
    return c > 3 && r && Object.defineProperty(target, key, r), r;
};
import React, { Component } from 'react';
import { inject, observer } from 'mobx-react';
import { T } from 'helpers/i18n';
import { toDate } from 'helpers/Format';
import history from 'helpers/History';
import Theme from 'Theme';
import { Col, Modal, ModalBody, ModalHeader, Row } from 'reactstrap';
import { tramoHora } from './TicketSales';
import { renderTicket } from '../components/Papel';
let TicketDetail = class TicketDetail extends Component {
    constructor() {
        super(...arguments);
        this.findUser = (lista, id) => {
            const result = lista.find(value => value.id === id);
            return result ? result.name : '';
        };
        this.handleOnSelectItem = (item) => {
            console.error(item.id);
        };
        this.toggle = () => {
            history.goBack();
        };
    }
    UNSAFE_componentWillMount() {
        // console.log('UNSAFE_componentWillMount')
        if (history.location.state === undefined) {
            history.goBack();
        }
    }
    componentDidMount() {
        // console.log('TicketGratis - componentDidMount')
        this.props.store.reports.readTicketGratis();
    }
    render() {
        const item = history.location.state;
        console.log('item: ', item);
        const { reports } = this.props.store;
        const headers = ['businessUnit', 'operationLine', 'stretch', 'numero', 'user', 'datecheck', 'terminal', 'netAmount', 'taxAmount', 'discount', 'total'];
        const items = reports.ticketGratis;
        const image = `${process.env.REACT_APP_SERVER}${item.image}`;
        // console.log('item.daterefund', item.daterefund)
        // console.log('image', image)
        const canceled = !!item.daterefund;
        // console.log('canceled', canceled)
        const externalCloseBtn = React.createElement("button", { className: "close", style: { color: Theme.color.primary, position: 'absolute', top: '50px', right: '15px', }, onClick: this.toggle }, "\u00D7");
        return (React.createElement("div", { className: "animated fadeIn" },
            React.createElement(Row, null,
                React.createElement(Col, null,
                    React.createElement(Modal, { centered: true, fade: true, isOpen: true, modalTransition: { timeout: 700 }, backdropTransition: { timeout: 1000 }, toggle: this.toggle, 
                        /*external={externalCloseBtn}*/
                        style: { width: '320px' } },
                        React.createElement("p", { style: { verticalAlign: 'baseline', margin: 0, marginTop: '-26px', padding: 0, fontSize: 25, width: '100%' } }, "................................................"),
                        React.createElement(ModalHeader, null, `Ticket ${item.id} - ${item.numero}`),
                        React.createElement(ModalBody, { style: { margin: 0, padding: 0 } }, renderTicket(item, this.props.store.stretchesStore.findBusinessunitByStretchId(item.stretch_id))))))));
    }
};
TicketDetail = __decorate([
    inject('store'),
    observer
], TicketDetail);
const renderExpiration = (item) => {
    const { timeExpiration } = item;
    // console.log('dateExpiration', timeExpiration)
    const expiration = new Date(item.datebook);
    expiration.setHours(23, 59, 59, 999);
    expiration.setDate(expiration.getDate() + timeExpiration);
    if (item.tramoHora) {
        const dateToShow = item.datebookNTZ ? item.datebookNTZ : item.datebook;
        const tramoHorario = tramoHora(typeof dateToShow === 'string' ? new Date(dateToShow) : dateToShow, item.hours, item.minutes);
        if (item.vuelta) {
            return (React.createElement("div", { style: { marginTop: 0 } },
                React.createElement("h6", null,
                    React.createElement("p", { style: { textAlign: 'center' } }, 'Válido para un solo uso de ida y vuelta')),
                fechasIguales(item.datebook, expiration) && React.createElement("h6", null,
                    React.createElement("p", { style: { marginTop: 0, marginBottom: 0, textAlign: 'center' } },
                        T('parael'),
                        " ",
                        toDate(expiration))),
                !fechasIguales(item.datebook, expiration) && React.createElement("h6", null,
                    React.createElement("p", { style: { marginTop: 0, marginBottom: 0, textAlign: 'center' } },
                        T('desde'),
                        " ",
                        toDate(item.datebook),
                        " a las ",
                        tramoHorario,
                        " ",
                        React.createElement("br", null),
                        " ",
                        React.createElement("br", null),
                        " ",
                        T('hasta'),
                        " ",
                        toDate(expiration),
                        React.createElement("br", null)))));
        }
        return (React.createElement("div", { style: { marginTop: 0 } },
            React.createElement("h6", null,
                React.createElement("p", { style: { textAlign: 'center' } }, 'Válido para un solo uso')),
            React.createElement("h6", null,
                React.createElement("p", { style: { marginTop: 0, marginBottom: 0, textAlign: 'center' } },
                    toDate(item.datebook),
                    " a las ",
                    tramoHorario,
                    " horas"))));
    }
    else {
        return (React.createElement("div", { style: { marginTop: 0 } },
            item.hoponHopoff && React.createElement("h2", null,
                React.createElement("p", { style: { textAlign: 'center' } }, 'HopON HopOFF')),
            !item.hoponHopoff && !item.vuelta && React.createElement("h6", null,
                React.createElement("p", { style: { textAlign: 'center' } }, 'Válido para un solo uso')),
            !item.hoponHopoff && item.vuelta && React.createElement("h6", null,
                React.createElement("p", { style: { textAlign: 'center' } }, 'Válido para un solo uso de ida y vuelta')),
            fechasIguales(item.datebook, expiration) && React.createElement("h6", null,
                React.createElement("p", { style: { marginTop: 0, marginBottom: 0, textAlign: 'center' } },
                    T('parael'),
                    " ",
                    toDate(expiration))),
            !fechasIguales(item.datebook, expiration) && React.createElement("h6", null,
                React.createElement("p", { style: { marginTop: 0, marginBottom: 0, textAlign: 'center' } },
                    T('desde'),
                    " ",
                    toDate(item.datebook),
                    " ",
                    T('hasta'),
                    " ",
                    toDate(expiration)))));
    }
};
const renderIdaVuelta = () => {
    return (React.createElement("div", null,
        React.createElement("h2", null,
            React.createElement("p", { style: { marginTop: 0, marginBottom: 0, textAlign: 'center' } }, 'IDA')),
        React.createElement("h2", null,
            React.createElement("p", { style: { textAlign: 'center' } }, 'VUELTA'))));
};
const fechasIguales = (date1, date2) => {
    return date1.getFullYear() === date2.getFullYear() &&
        date1.getMonth() === date2.getMonth() &&
        date1.getDate() === date2.getDate();
};
export default TicketDetail;



//////////////////
// WEBPACK FOOTER
// ./src/modules/Reports/containers/TicketDetail.tsx
// module id = 531
// module chunks = 0